import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpEventType, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable, Subject, retry, timer } from 'rxjs';

import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  url: string = environment.mongoApiUrl;
  careerUrl = environment.careerUrl;
  companyHiringTypeId = +localStorage.getItem('fresherCompHiringTypeId');
  offerUrl = environment.offerTest;
  retryDelay = window["retryDelay"]; // Delay in milliseconds before retrying the request
  constructor(private httpClient: HttpClient) { }
  fileSubject = new Subject<any[]>();
  schedulerUrl = environment.schedulerDashboardUrl;

  public upload(data) {
    const uploadURL = this.url + 'uploadFileData';
    // let headers = new Headers();
    const requestOptions: object = {
      reportProgress: true,
      observe: 'events',
      'Content-Type': 'multipart/form-data',
    };

    const request$ = this.httpClient.post<any>(uploadURL, data, requestOptions).pipe(map((event) => {

      switch (event.type) {

        case HttpEventType.UploadProgress:

          const progress = Math.round(100 * event.loaded / event.total);
          return { status: 'progress', message: progress, progressTime: event.loaded, fileTotalSize: event.total };

        case HttpEventType.Response:
          return event.body;
        default:
          return `Unhandled event: ${event.type}`;
      }
    }));

    return this.retryDelay
      ? request$.pipe(retry({ count: 1, delay: (error) => {
          if (error instanceof HttpErrorResponse && error.status === 502) {
            console.log('retrying now...');
            return timer(this.retryDelay);
          }
          throw error;
        } }))
      : request$;
  }

  public deleteFile(fileID) {
    const uploadURL = this.url + 'deleteFileData?id=' + fileID;
    return this.httpClient.delete(`${uploadURL}`, { responseType: 'text' });
  }

  setFileUploadEvent(file: any) {
    this.fileSubject.next(file);
  }

  get fileUploaded() {
    return this.fileSubject.asObservable();
  }

  public downloadFile(fileID) {
    return this.httpClient.get<any>(this.url + 'downloadFileNew?id=' + fileID);
  }

  public getFileData(ojectId, ojectType) {
    return this.httpClient.get<any>(this.url + 'getFileData/' + ojectId + '/' + ojectType);
  }

  public uploadData(data) {
    // this.url = environment.mongoApiUrl + 'file/';
    const uploadURL = this.url + 'uploadFileData';
    // let headers = new Headers();
    const requestOptions: object = {
      reportProgress: true,
      observe: 'events',
      'Content-Type': 'multipart/form-data',
      'Access-Control-Allow-Origin': '*',
    };

    const request$ = this.httpClient.post<any>(uploadURL, data, requestOptions).pipe(map((event) => {

      switch (event.type) {
        case HttpEventType.UploadProgress:
        // const progress = Math.round(100 * event.loaded / event.total); 
        // return { status: 'progress', message: progress, progressTime: event.loaded, fileTotalSize:event.total };
        case HttpEventType.Response:
          return event;
        default:
          return `Unhandled event: ${event.type}`;
      }
    }));

     return this.retryDelay
      ? request$.pipe(retry({ count: 1, delay: (error) => {
          if (error instanceof HttpErrorResponse && error.status === 502) {
            console.log('retrying now...');
            return timer(this.retryDelay);
          }
          throw error;
        } }))
      : request$;
  }
  getFile(candidateId, applicationId) {
    return this.httpClient.get<any>(this.schedulerUrl + 'getFileOffer/' + candidateId + '/' + applicationId);
  }

  public getActivityFileData(objectId, objectType, activityId) {
    console.log(activityId);
    return this.httpClient.get<any>(this.url + 'getFileDataActivity/' + objectId + '/' + objectType + '/' + activityId);
  }
  saveAttachments(attachReqBody: any): Observable<any> {
    const requestOptions: object = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };
    const baseUrl = environment.mongoApiUrl;
    return this.httpClient.post<any>(baseUrl + 'uploadFileDataForm', attachReqBody, requestOptions);
  }

  getAttachmentType(objType) {
    return this.httpClient.get<any>(
      this.careerUrl +
        `v1/attachment/getAttachmentTypes?objectType=${objType}&companyHiringTypeId=${this.companyHiringTypeId}`,
    );
  }

  getMultipleFiles(applnId): Observable<any> {
    return this.httpClient.get<any>(this.url + 'getAllFilesOfObj/' + applnId + '/OF');
  }

  getDpSfoAttachmentIds(applicationId) {
    return this.httpClient.get<any>(this.offerUrl + 'v1/getAttachmentIds/' + applicationId + '/500306,600301');
  }
}
